import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, deleteSeriesEntry } from 'store/data/entries';

type HandlerInput = Parameters<typeof deleteSeriesEntry>[0];

export function useDeleteSeriesEntry(): Operation<(input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.DELETE_SERIES_ENTRY);

	function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(deleteSeriesEntry(input));
	}

	return [{ loading, error }, handler];
}
